import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import {
  Biometrichexagon,
  BodyWeight,
  ClientReportExercises,
  ClientReportHead,
  Reportbutton,
  ReportNotes,
} from "../report";
import { getClientReportById } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { toggle } from "../../redux";

const FitnessReportPreviewsSummary = () => {
  const { clientId } = useParams();
  const { report } = useSelector((state) => state.client);
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.navbar.button);

  useEffect(() => {
    getClientReportById(clientId);
  }, [clientId]);

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  return (
    <div onClick={handleMainContainerClick}>
      <Navbar />
      <ClientReportHead report={report} />
      <ClientReportExercises report={report} />
      <Biometrichexagon report={report} />
      <BodyWeight report={report} />
      <ReportNotes report={report} />
      <Reportbutton clientId={clientId} report={report} />
    </div>
  );
};

export default FitnessReportPreviewsSummary;
